import i18next from 'i18next';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import common from './common';
import commonTranslation from '../translations/common';
import reviewImages from '../translations/reviewImages';
import customFeesLordgun from '../translations/customFees.lordgun';
import customFeesRunkd from '../translations/customFees.runkd';
import customFeesInwild from '../translations/customFees.inwild';
import cartSummary from '../translations/cartSummary.js';
import cartCheckout from '../translations/cartCheckout.js';
import reassortmentNotification from '../translations/reassortmentNotification';
import paymentInfo from '../translations/paymentInfo';
import nicknameValidator from '../translations/nicknameValidator';
import disbursementSimulator from '../translations/disbursementSimulator';
import cookieConsentLordgun from '../translations/cookieConsent.lordgun';
import cookieConsentRunkd from '../translations/cookieConsent.runkd';
import cookieConsentInwild from '../translations/cookieConsent.inwild';
import socialLinks from '../translations/socialLinks';
import blog from '../translations/blog/blog';
import productCard from '../translations/productCard';
import recentlyViewedProducts from '../translations/product/recentlyViewedProducts';
import productDetail from '../translations/product/detail';
import carousel from '../translations/carousel';
import topBrands from '../translations/brands/topBrands';
import cartRightSummary from '../translations/cartRightSummary';
import topBlogPosts from '../translations/blog/topBlogPosts';
import serviceLinks from '../translations/serviceLinks';
import reviews from '../translations/reviews/reviews';
import questions from '../translations/questionAndAnswers/questions';
import feedbacks from '../translations/feedbacks/feedbacks';
import bannerRedirectLordgun from '../translations/bannerRedirect.lordgun';
import bannerRedirectRunkd from '../translations/bannerRedirect.runkd';
import bannerRedirectInwild from '../translations/bannerRedirect.inwild';
import form from '../translations/form/form';
import home from '../translations/home/homeTranslations';
import orders from '../translations/orders/orders';
import returns from '../translations/returns/returns';
import search from '../translations/search';
import newsletter from '../translations/newsletter';
import lowerPrice from '../translations/product/lowerPrice';

const configHelper = require('../config/index.js');

let initialized = false;
const commonTranslations = [
  { reviewImages },
  { common: commonTranslation },
  { cartSummary },
  { cartCheckout },
  { reassortmentNotification },
  { nicknameValidator },
  { disbursementSimulator },
  { paymentInfo },
  { socialLinks },
  { blog },
  { productCard },
  { recentlyViewedProducts },
  { carousel },
  { topBrands },
  { cartRightSummary },
  { topBlogPosts },
  { serviceLinks },
  { productDetail },
  { reviews },
  { questions },
  { feedbacks },
  { form },
  { home },
  { orders },
  { returns },
  { search },
  { newsletter },
  { lowerPrice },
];
const translationsForLordgun = commonTranslations.concat([
  { customFees: customFeesLordgun },
  { cookieConsent: cookieConsentLordgun },
  { bannerRedirect: bannerRedirectLordgun },
]);
const translationsForRunkd = commonTranslations.concat([
  { customFees: customFeesRunkd },
  { cookieConsent: cookieConsentRunkd },
  { bannerRedirect: bannerRedirectRunkd },
]);
const translationsForInwild = commonTranslations.concat([
  { customFees: customFeesInwild },
  { cookieConsent: cookieConsentInwild },
  { bannerRedirect: bannerRedirectInwild },
]);
let translations;

switch (common.getSite()) {
  case 'lordgun':
    translations = translationsForLordgun;
    break;
  case 'runkd':
    translations = translationsForRunkd;
    break;
  case 'inwild':
    translations = translationsForInwild;
    break;
}

const getMappedTranslation = (culture, translations) => {
  const mappedTranslation = reduce(
    translations,
    (acc, translation) => {
      let key = keys(translation)[0];
      acc[key] = translation[key][culture];
      return acc;
    },
    {},
  );
  return mappedTranslation;
};

const init = () => {
  if (initialized === false) {
    let staticResources = reduce(
      configHelper.getConfig().supportedCultures(),
      (acc, culture) => {
        acc[culture] = {
          translation: getMappedTranslation(culture, translations),
        };
        return acc;
      },
      {},
    );
    i18next.init({
      lng: common.getLang(),
      resources: staticResources,
    });
    initialized = true;
  }
  return initialized;
};

export default {
  get: (key) => {
    if (init()) {
      const translation = i18next.t(key);
      return translation;
    }
    throw new Error('translateService not initialized');
  },
  interpolate: (key, params) => {
    if (init()) {
      let translation = i18next.t(key);
      translation = _.reduce(
        _.keys(params),
        (acc, paramKey) => {
          acc = _.replace(acc, `{${paramKey}}`, `${params[paramKey]}`);
          return acc;
        },
        translation,
      );
      return translation;
    }
    throw new Error('translateService not initialized');
  },
};
